import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";

import RAHPRegulations2026 from "../../assets/pdf/regulations/RAHPRegulations2026.pdf";

const Regulations = ({ regulationsDataProp }) => {
  document.title = "Regulations | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Array of regulations data: { title, link }
  const regulationsData = regulationsDataProp || [
    {
      title:
        "Registration of Allied and Healthcare Professionals Regulations,2026",
      link: RAHPRegulations2026,
    },
  ];

  return (
    <div className="wrappermain">
      {/*Regulations Banner Section */}
      <div
        className="banner-image wrappermain"
        style={{
          backgroundImage: "url(" + Background_Member2 + ")",
          backgroundPosition: "right",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "25px 0",
        }}
      >
        <div className="banner-inner-breadcrumb">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/"}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Regulations
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/*Regulations Table Section */}
      <div className="container my-5">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Regulations</th>
              </tr>
            </thead>
            <tbody>
              {regulationsData.length ? (
                regulationsData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="custom-link"
                      >
                        {item.title}
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={1} className="text-center">
                    No regulations available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Regulations;
